import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Grid } from '@material-ui/core';
import HealthProfileCard from './HealthProfileCard';

export default function HealthProfileSection(props) {
  return (
    <div style={{ marginBottom: '25px' }}>
      <Grid container justify="center" direction="column">
        <Grid
          item
          xs={12}
          style={{ paddingTop: '30px', paddingBottom: '10px' }}
        >
          <Typography variant={'h2'} style={{ fontSize: '16px' }}>
            {props.title}
          </Typography>
        </Grid>

        <Grid item xs={12}>
          <Grid container justify="center" direction="row">
            {props.cards &&
              props.cards.map((card, ix) => {
                return (
                  <Grid item xs={card.span ? card.span : 6} key={ix}>
                    <HealthProfileCard {...card} />
                  </Grid>
                );
              })}
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}

HealthProfileSection.propTypes = {
  title: PropTypes.string.isRequired,
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      valueColor: PropTypes.string.isRequired,
      illustration: PropTypes.object,
      redirectPath: PropTypes.string.isRequired,
      redirectStep: PropTypes.number.isRequired,
    })
  ),
};
